// Deployment configuration - injected at build time
export const DEPLOYMENT_CONFIG = {
  type: 'singleapp-private',
  defaultApp: 'heston',
  apiUrl: 'https://w3drvw1n57.execute-api.us-east-1.amazonaws.com/prod'
};
